const handleValue = (value, setFn) => {
  value.trim()
  setFn(value)
}

export default handleValue
